<div
    class="flex items-center justify-center w-10 h-10 cursor-pointer settings-cog z-90 print:hidden"
    [class.lg:right-0]="
        config.layout === 'centered' || config.layout === 'material'
    "
    [class.lg:right-16]="
        config.layout !== 'centered' && config.layout !== 'material'
    "
    (click)="settingsDrawer.toggle()"
>
    <mat-icon
        class="icon-size-5 animate-spin-slow"
        [svgIcon]="'heroicons_solid:cog'"
    ></mat-icon>
</div>

<fuse-drawer
    class="w-screen min-w-screen sm:w-100 sm:min-w-100 z-999"
    fixed
    [mode]="'over'"
    [name]="'settingsDrawer'"
    [position]="'right'"
    #settingsDrawer
>
    <div class="flex flex-col w-full overflow-auto bg-card">
        <div
            class="flex flex-col h-20 px-6 text-white justify-evenly min-h-20 dark:bg-primary-800 bg-primary"
        >
            <div class="flex flex-row items-center">
                <mat-icon
                    class="text-current icon-size-7"
                    [svgIcon]="'heroicons_solid:cog'"
                ></mat-icon>
                <div class="ml-3 text-2xl font-semibold tracking-tight">
                    {{ "settings.title" | transloco }}
                </div>
                <button
                    class="ml-auto"
                    mat-icon-button
                    (click)="settingsDrawer.close()"
                >
                    <mat-icon
                        class="text-current"
                        [svgIcon]="'heroicons_outline:x'"
                    ></mat-icon>
                </button>
            </div>
            <ng-container *ngIf="loggedUser">
                <div class="flex items-center justify-between">
                    <span class="leading-none">
                        <span>{{ "signed-in-as" | transloco }}</span>
                        <span class="ml-1.5 text-accent text-md font-medium">{{
                            loggedUser.email || "agritrack@email.com"
                        }}</span>
                    </span>
                    <button class="flex items-center" (click)="signOut()">
                        <mat-icon
                            class="text-accent"
                            [svgIcon]="'heroicons_outline:logout'"
                        ></mat-icon>
                        <span class="ml-1.5 hover:text-accent">{{
                            "sign-out" | transloco
                        }}</span>
                    </button>
                </div>
            </ng-container>
        </div>

        <div class="flex flex-col px-6 py-3 overflow-auto">
            <!-- User information -->
            <div class="font-semibold text-md text-secondary">
                {{ "settings.user" | transloco }}
            </div>
            <form [formGroup]="settingsService.form" (ngSubmit)="onSubmit()">
                <div class="flex flex-col mt-3">
                    <div *ngIf="!imageChangedEvent" class="self-center">
                        <img
                            *ngIf="!loggedUser?.photo"
                            src="../../../assets/images/avatars/avatar.png"
                            alt="User picture"
                            class="object-cover rounded-full w-[150px] h-[150px]"
                        />
                        <img
                            *ngIf="loggedUser?.photo"
                            src="{{ loggedUser.photo }}"
                            alt="User picture"
                            class="object-cover rounded-full w-[150px] h-[150px]"
                        />
                    </div>
                    <ng-container *ngIf="imageChangedEvent">
                        <image-cropper
                            class="w-11/12 max-w-[380px] h-11/12 self-center border-2 border-primary dark:border-none"
                            [imageChangedEvent]="imageChangedEvent"
                            [maintainAspectRatio]="false"
                            [aspectRatio]="4 / 3"
                            format="png"
                            (imageCropped)="imageCropped($event)"
                            (imageLoaded)="imageLoaded()"
                            (cropperReady)="cropperReady()"
                            (loadImageFailed)="loadImageFailed()"
                        ></image-cropper>
                    </ng-container>
                    <label
                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        for="image_file"
                        >{{ "settings.photo" | transloco }}</label
                    >
                    <input
                        formControlName="image"
                        id="image_file"
                        type="file"
                        (change)="fileChangeEvent($event)"
                        class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                    />

                    <hr *ngIf="imageChangedEvent" class="mt-3 mb-0" />
                </div>

                <div
                    class="grid items-start justify-center grid-cols-2 gap-3 mt-3"
                >
                    <div>
                        <label
                            for="first_name"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.first_name" | transloco }}</label
                        >
                        <input
                            formControlName="first_name"
                            type="text"
                            id="first_name"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="John"
                            readonly
                        />
                    </div>
                    <div>
                        <label
                            for="last_name"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.last_name" | transloco }}</label
                        >
                        <input
                            formControlName="last_name"
                            type="text"
                            id="last_name"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Doe"
                            readonly
                        />
                    </div>
                    <div>
                        <label
                            for="user_name"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.user_name" | transloco }}</label
                        >
                        <input
                            formControlName="user_name"
                            type="text"
                            id="user_name"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Username"
                            readonly
                        />
                    </div>
                    <div>
                        <label
                            for="phone"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.phone" | transloco }}</label
                        >
                        <input
                            formControlName="phone"
                            type="tel"
                            id="phone"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="6971313678"
                            pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                            readonly
                        />
                    </div>
                    <div>
                        <label
                            for="email"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.email" | transloco }}</label
                        >
                        <input
                            formControlName="email"
                            type="email"
                            id="email"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="john.doe@agritrack.com"
                            readonly
                        />
                    </div>
                    <div>
                        <label
                            for="last_login"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.last_login" | transloco }}</label
                        >
                        <input
                            formControlName="last_login_at"
                            type="text"
                            id="last_login"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Last login"
                            readonly
                        />
                    </div>
                    <div>
                        <label
                            for="registered_at"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.registered_at" | transloco }}</label
                        >
                        <input
                            formControlName="registered_at"
                            type="text"
                            id="registered_at"
                            class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Registered at"
                            readonly
                        />
                    </div>
                    <div class="col-span-2">
                        <!-- <label for="sites" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{'settings.site' | transloco}}</label>
                            <input formControlName="sites" type="text" id="sites" class="bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Default site" readonly>
                         -->
                        <label
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.site" | transloco }}</label
                        >
                        <div
                            class="block bg-hover border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        >
                            <ul
                                class="pl-5 list-disc items-center overflow-y-auto min-h-[18px] max-h-[75px] grid grid-cols-2"
                            >
                                <ng-container
                                    *ngFor="let site of loggedUserSiteList"
                                >
                                    <li>{{ site }}</li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                    <div class="col-span-2">
                        <label
                            for="language"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.language" | transloco }}</label
                        >

                        <div
                            id="language"
                            class="grid items-start justify-center grid-cols-2 gap-3"
                        >
                            <ng-container
                                *ngFor="let lang of availableLanguages"
                            >
                                <div
                                    value="{{ lang.id }}"
                                    class="flex items-center justify-center py-3 pl-5 pr-6 text-center rounded-full cursor-pointer ring-inset ring-primary dark:ring-accent bg-hover"
                                    [class.ring-2]="defaultLang === lang.id"
                                    (click)="setActiveLang(lang.id)"
                                >
                                    <div
                                        class="flex items-center overflow-hidden"
                                    >
                                        <span class="flex items-center">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    flagImage;
                                                    context: {
                                                        $implicit: lang.id
                                                    }
                                                "
                                            ></ng-container>
                                        </span>
                                    </div>
                                    <div
                                        class="flex items-center ml-2 text-sm font-medium leading-5"
                                        [class.text-secondary]="
                                            defaultLang !== lang.id
                                        "
                                    >
                                        {{ lang.value }}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-span-2">
                        <label
                            for="schm"
                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >{{ "settings.schm" | transloco }}</label
                        >
                        <div
                            id="schm"
                            class="grid items-start justify-center grid-cols-2 gap-3"
                        >
                            <ng-container *ngFor="let theme of availableThemes">
                                <div
                                    value="{{ theme.id }}"
                                    class="flex items-center justify-center py-3 pl-5 pr-6 text-center rounded-full cursor-pointer ring-inset ring-primary dark:ring-accent bg-hover"
                                    [class.ring-2]="config.scheme === theme.id"
                                    (click)="setScheme(theme.id)"
                                >
                                    <div
                                        class="flex items-center overflow-hidden rounded-full"
                                    >
                                        <mat-icon
                                            *ngIf="theme.id === 'light'"
                                            class="icon-size-5"
                                            [svgIcon]="'heroicons_solid:sun'"
                                        ></mat-icon>
                                        <mat-icon
                                            *ngIf="theme.id === 'dark'"
                                            class="icon-size-5"
                                            [svgIcon]="'heroicons_solid:moon'"
                                        ></mat-icon>
                                    </div>
                                    <div
                                        class="flex items-center ml-2 text-sm font-medium leading-5"
                                        [class.text-secondary]="
                                            config.scheme !== theme.id
                                        "
                                    >
                                        {{ theme.value }}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="imageChangedEvent; else justSave">
                    <div class="max-w-[380px] flex self-center gap-2 mb-2">
                        <button
                            type="submit"
                            class="mt-4 basis-1/2 text-white bg-primary-400 hover:bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-accent-600 dark:hover:bg-accent-700 dark:focus:ring-accent-800"
                        >
                            {{ "settings.save" | transloco }}
                        </button>
                        <button
                            (click)="discardImage()"
                            class="basis-1/2 mt-4 text-white bg-warn-600 hover:bg-warn focus:ring-4 focus:outline-none focus:ring-warn-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                        >
                            {{ "settings.discard" | transloco }}
                        </button>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</fuse-drawer>

<!-- Default button when there is no image selected -->
<ng-template #justSave>
    <button
        type="submit"
        class="mt-4 w-full text-white bg-primary-400 hover:bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-accent-600 dark:hover:bg-accent-700 dark:focus:ring-accent-800"
    >
        {{ "settings.save" | transloco }}
    </button>
</ng-template>

<!-- Flag image template -->
<ng-template let-lang #flagImage>
    <span class="relative w-5 shadow overflow-hidden-sm">
        <span
            class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
        ></span>
        <img
            class="w-full"
            [src]="
                'assets/images/flags/' + flagCodes[lang].toUpperCase() + '.svg'
            "
            [alt]="'Flag image for ' + lang"
        />
    </span>
</ng-template>
